
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { SubGroupForm } from "@univdiam/ui/customComponents/SubGroupList/SubGroupForm"
// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function SubGroupAdd() {
  const [groupData, setGroupData] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
      const fetchGroup = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/groups`)
          if (response.status === 200 && response.data) {
            const group = response.data.data
            // Map fields to your form shape
            const transformed = group.map((group: any) => ({
              group_id: group.group_id.toString(),
              name: group.name,
              status: group.status === 1 ? "Enabled" : "Disabled"
            }))
            setGroupData(transformed)
          }
        } catch (err) {
          console.error("Failed to fetch group", err)
          navigate("/sub-group")
        }
      }
    
      fetchGroup()
    }, [])

    const handleAddSubGroup = async (data: any) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/sub_groups/add`, data)

            if (response.status === 201 || response.status === 200) {
              alert("SubGroup created successfully!")
              navigate("/sub-group")
            }
        } catch (error) {
            console.error("Error creating group:", error)
            alert("Failed to create group.")
        }
    }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Sub Group</h1>
      <SubGroupForm onSubmit={handleAddSubGroup} groupValues={groupData}  />
    </div>
  )
}
